import { render, staticRenderFns } from "./fieldMoney.vue?vue&type=template&id=1dda45bc&scoped=true&"
import script from "./fieldMoney.vue?vue&type=script&lang=js&"
export * from "./fieldMoney.vue?vue&type=script&lang=js&"
import style0 from "./fieldMoney.vue?vue&type=style&index=0&id=1dda45bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda45bc",
  null
  
)

export default component.exports